/* eslint-disable */
import Header from "components/Common/Header/Header";
import CompanyArticlesBody from "components/CompaniesComponents/CompanyDetails/CompanyArticles/ArticlesBody/CompanyArticlesBody";
import React, { useEffect } from "react";

const CompanyArticles = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Company Articles";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="companies" />

      {/* ------ body section --------- */}
      <CompanyArticlesBody />
    </main>
  );
};

export default CompanyArticles;
